import { TransactionSourceType, TransactionType } from '@pflegenavi/shared/api';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import { Label, Stack } from '@pflegenavi/web-components';

interface TwoLineTypeLabelProps {
  typeText: string;
  statusText?: string;
  type: TransactionType;
  sourceType: TransactionSourceType;
  paymentColor?: 'warning' | 'error' | 'info' | 'success';
}

export const TwoLineTypeLabel: FC<TwoLineTypeLabelProps> = ({
  typeText,
  statusText,
  type,
  sourceType,
  paymentColor,
}) => {
  const color = useMemo(() => {
    // Use paymentColor from the payment formatter if provided
    if (paymentColor) {
      return paymentColor;
    }

    // Fallback to original logic for backward compatibility
    if (
      sourceType === TransactionSourceType.CancelledReceipt ||
      sourceType === TransactionSourceType.CancelledManualDeposit ||
      sourceType === TransactionSourceType.Dispute
    ) {
      return 'warning';
    }
    if (type === TransactionType.DEPOSIT) {
      return 'success';
    }
    if (type === TransactionType.WITHDRAWAL) {
      return 'info';
    }
    return 'default';
  }, [sourceType, type, paymentColor]);

  return (
    <Stack spacing={0.5} alignItems="flex-start">
      <Label variant="ghost" color={color} sx={{ textTransform: 'capitalize' }}>
        {typeText}
      </Label>
      {statusText && (
        <Label
          variant="ghost"
          color="error"
          sx={{
            textTransform: 'capitalize',
            fontSize: 12,
            fontWeight: 600,
          }}
        >
          {statusText}
        </Label>
      )}
    </Stack>
  );
};
